
import * as React from 'react'
import { Dialog, DialogTitle, Button, DialogContent, DialogActions, Typography  } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close'
import {styled} from '@mui/material/styles'

const CustomDialog = styled(Dialog)(({theme})=>({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
      },
      '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
      },
  
  }));


  export const DocumentConfirmed =({open, handleClose}) =>{

    return(
        <CustomDialog open={open} onClose={handleClose}>
            <DialogTitle sx={{padding: 1, mr: 3}} onClose={handleClose}>
                The Document has Been Confirmed
            </DialogTitle>
                <DialogContent dividers>
                    <Typography gutterBottom>
                        The Document has been Confirmed.  The Debt has been Reconciled. 
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleClose} color ='secondary' endIcon={<CloseIcon />}>
                        Close
                    </Button>
                </DialogActions>
        </CustomDialog>


    )
  }